module.exports = __webpack_public_path__ + "static/seta2-b39f9d11f258bd7983b9a2dbe29eba15.png";